import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { kullaniciService } from '../api/dbService';
import PageLayout from '../components/PageLayout';
import LoadingSpinner from '../components/LoadingSpinner';

const ROL_RENK = { admin: 'danger', manager: 'warning', user: 'primary', viewer: 'secondary' };
const ROL_LABEL = { admin: 'Admin', manager: 'Manager', user: 'User', viewer: 'Viewer' };

const CREATABLE = {
  admin:   ['admin', 'manager', 'user', 'viewer'],
  manager: ['user', 'viewer'],
  user:    ['viewer'],
  viewer:  []
};

const EMPTY_FORM = { username: '', email: '', password: '', ad_soyad: '', telefon: '', firma: '', rol: '' };

export default function UserManagement() {
  const currentUser = JSON.parse(localStorage.getItem('current_user') || '{}');
  const myRole = currentUser.role || currentUser.rol || 'viewer';
  const creatableRoles = CREATABLE[myRole] || [];

  const [kullanicilar, setKullanicilar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ekleModal, setEkleModal] = useState(false);
  const [duzenleModal, setDuzenleModal] = useState(null); // kullanıcı objesi
  const [sifreModal, setSifreModal] = useState(null);     // kullanıcı id
  const [form, setForm] = useState(EMPTY_FORM);
  const [duzenleForm, setDuzenleForm] = useState({});
  const [yeniSifre, setYeniSifre] = useState('');
  const [yeniSifre2, setYeniSifre2] = useState('');
  const [saving, setSaving] = useState(false);

  function loadUsers() {
    setLoading(true);
    kullaniciService.getKullanicilar()
      .then(res => setKullanicilar(res.data || []))
      .catch(() => toast.error('Kullanıcılar yüklenemedi'))
      .finally(() => setLoading(false));
  }

  useEffect(() => { loadUsers(); }, []);

  async function handleEkle(e) {
    e.preventDefault();
    if (!form.rol) return toast.error('Rol seçiniz');
    setSaving(true);
    try {
      await kullaniciService.createKullanici(form);
      toast.success('Kullanıcı oluşturuldu');
      setEkleModal(false);
      setForm(EMPTY_FORM);
      loadUsers();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Oluşturulamadı');
    } finally { setSaving(false); }
  }

  async function handleDuzenle(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await kullaniciService.updateKullanici(duzenleModal.id, duzenleForm);
      toast.success('Güncellendi');
      setDuzenleModal(null);
      loadUsers();
    } catch { toast.error('Güncellenemedi'); }
    finally { setSaving(false); }
  }

  async function handleSifreDegistir() {
    if (yeniSifre !== yeniSifre2) return toast.error('Parolalar eşleşmiyor');
    if (yeniSifre.length < 6) return toast.error('En az 6 karakter');
    setSaving(true);
    try {
      await kullaniciService.sifreDegistir(sifreModal, { yeni_sifre: yeniSifre });
      toast.success('Şifre değiştirildi');
      setSifreModal(null); setYeniSifre(''); setYeniSifre2('');
    } catch { toast.error('Başarısız'); }
    finally { setSaving(false); }
  }

  async function handleAktifToggle(k) {
    try {
      await kullaniciService.setAktif(k.id, !k.aktif);
      setKullanicilar(prev => prev.map(u => u.id === k.id ? { ...u, aktif: !k.aktif } : u));
      toast.success(k.aktif ? 'Kullanıcı pasife alındı' : 'Kullanıcı aktif edildi');
    } catch { toast.error('İşlem başarısız'); }
  }

  async function handleSil(k) {
    if (!window.confirm(`"${k.username}" silinecek. Emin misiniz?`)) return;
    try {
      await kullaniciService.silKullanici(k.id);
      setKullanicilar(prev => prev.filter(u => u.id !== k.id));
      toast.success('Silindi');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Silinemedi');
    }
  }

  function canManage(target) {
    if (target.id === currentUser.id) return false;
    return creatableRoles.includes(target.rol);
  }

  if (loading) return <PageLayout><LoadingSpinner /></PageLayout>;

  return (
    <PageLayout>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 fw-semibold">Kullanıcı Yönetimi</h5>
        {creatableRoles.length > 0 && (
          <button className="btn btn-brand btn-sm" onClick={() => { setForm({ ...EMPTY_FORM, rol: creatableRoles[creatableRoles.length - 1] }); setEkleModal(true); }}>
            <i className="fas fa-user-plus me-1"></i>Kullanıcı Ekle
          </button>
        )}
      </div>

      <div className="card">
        <div className="table-responsive">
          <table className="table table-hover table-sm align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>Kullanıcı Adı</th><th>E-posta</th><th>Ad Soyad</th><th>Firma</th>
                <th>Rol</th><th>Durum</th><th>Kayıt</th><th></th>
              </tr>
            </thead>
            <tbody>
              {kullanicilar.length === 0 && (
                <tr><td colSpan={8} className="text-center text-muted py-4">Kullanıcı bulunamadı</td></tr>
              )}
              {kullanicilar.map(k => (
                <tr key={k.id} style={k.id === currentUser.id ? { background: 'rgba(14,165,233,.04)' } : {}}>
                  <td>
                    {k.username}
                    {k.id === currentUser.id && <span className="badge bg-secondary ms-1" style={{ fontSize: '.65rem' }}>Ben</span>}
                  </td>
                  <td><small className="text-muted">{k.email}</small></td>
                  <td>{k.ad_soyad || '—'}</td>
                  <td><small>{k.firma || '—'}</small></td>
                  <td>
                    <span className={`badge bg-${ROL_RENK[k.rol] || 'secondary'}`}>
                      {ROL_LABEL[k.rol] || k.rol}
                    </span>
                  </td>
                  <td>
                    <span className={`badge bg-${k.aktif ? 'success' : 'secondary'}`}>
                      {k.aktif ? 'Aktif' : 'Pasif'}
                    </span>
                  </td>
                  <td><small className="text-muted">{new Date(k.olusturma_tarihi).toLocaleDateString('tr-TR')}</small></td>
                  <td>
                    {canManage(k) ? (
                      <div className="d-flex gap-1 flex-wrap">
                        {myRole === 'admin' && (
                          <button
                            className={`btn btn-sm py-0 ${k.aktif ? 'btn-outline-secondary' : 'btn-outline-success'}`}
                            onClick={() => handleAktifToggle(k)}
                          >{k.aktif ? 'Pasif' : 'Aktif Et'}</button>
                        )}
                        <button className="btn btn-outline-primary btn-sm py-0" onClick={() => {
                          setDuzenleModal(k);
                          setDuzenleForm({ ad_soyad: k.ad_soyad || '', telefon: k.telefon || '', firma: k.firma || '', adres: k.adres || '' });
                        }}>Düzenle</button>
                        <button className="btn btn-outline-warning btn-sm py-0" onClick={() => { setSifreModal(k.id); setYeniSifre(''); setYeniSifre2(''); }}>Şifre</button>
                        <button className="btn btn-outline-danger btn-sm py-0" onClick={() => handleSil(k)}>Sil</button>
                      </div>
                    ) : (
                      <span className="text-muted small">—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Kullanıcı Ekle Modal */}
      {ekleModal && (
        <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 460 }}>
            <div className="modal-content">
              <form onSubmit={handleEkle}>
                <div className="modal-header">
                  <h6 className="modal-title">Yeni Kullanıcı Ekle</h6>
                  <button type="button" className="btn-close" onClick={() => setEkleModal(false)} />
                </div>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-6">
                      <label className="form-label">Kullanıcı Adı *</label>
                      <input className="form-control" required value={form.username} onChange={e => setForm(f => ({ ...f, username: e.target.value }))} />
                    </div>
                    <div className="col-6">
                      <label className="form-label">Rol *</label>
                      <select className="form-select" required value={form.rol} onChange={e => setForm(f => ({ ...f, rol: e.target.value }))}>
                        {creatableRoles.map(r => <option key={r} value={r}>{ROL_LABEL[r]}</option>)}
                      </select>
                    </div>
                    <div className="col-12">
                      <label className="form-label">E-posta *</label>
                      <input type="email" className="form-control" required value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
                    </div>
                    <div className="col-12">
                      <label className="form-label">Parola *</label>
                      <input type="password" className="form-control" required minLength={6} value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
                    </div>
                    <div className="col-6">
                      <label className="form-label">Ad Soyad</label>
                      <input className="form-control" value={form.ad_soyad} onChange={e => setForm(f => ({ ...f, ad_soyad: e.target.value }))} />
                    </div>
                    <div className="col-6">
                      <label className="form-label">Telefon</label>
                      <input className="form-control" value={form.telefon} onChange={e => setForm(f => ({ ...f, telefon: e.target.value }))} />
                    </div>
                    <div className="col-12">
                      <label className="form-label">Firma</label>
                      <input className="form-control" value={form.firma} onChange={e => setForm(f => ({ ...f, firma: e.target.value }))} />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => setEkleModal(false)}>İptal</button>
                  <button type="submit" className="btn btn-brand btn-sm" disabled={saving}>
                    {saving ? 'Oluşturuluyor...' : 'Oluştur'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Düzenle Modal */}
      {duzenleModal && (
        <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 420 }}>
            <div className="modal-content">
              <form onSubmit={handleDuzenle}>
                <div className="modal-header">
                  <h6 className="modal-title">Düzenle — {duzenleModal.username}</h6>
                  <button type="button" className="btn-close" onClick={() => setDuzenleModal(null)} />
                </div>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-6">
                      <label className="form-label">Ad Soyad</label>
                      <input className="form-control" value={duzenleForm.ad_soyad} onChange={e => setDuzenleForm(f => ({ ...f, ad_soyad: e.target.value }))} />
                    </div>
                    <div className="col-6">
                      <label className="form-label">Telefon</label>
                      <input className="form-control" value={duzenleForm.telefon} onChange={e => setDuzenleForm(f => ({ ...f, telefon: e.target.value }))} />
                    </div>
                    <div className="col-12">
                      <label className="form-label">Firma</label>
                      <input className="form-control" value={duzenleForm.firma} onChange={e => setDuzenleForm(f => ({ ...f, firma: e.target.value }))} />
                    </div>
                    <div className="col-12">
                      <label className="form-label">Adres</label>
                      <textarea className="form-control" rows="2" value={duzenleForm.adres} onChange={e => setDuzenleForm(f => ({ ...f, adres: e.target.value }))} />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => setDuzenleModal(null)}>İptal</button>
                  <button type="submit" className="btn btn-brand btn-sm" disabled={saving}>
                    {saving ? 'Kaydediliyor...' : 'Kaydet'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Şifre Modal */}
      {sifreModal && (
        <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 360 }}>
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title">Şifre Sıfırla</h6>
                <button className="btn-close" onClick={() => setSifreModal(null)} />
              </div>
              <div className="modal-body">
                <input type="password" className="form-control mb-2" placeholder="Yeni şifre (min 6 karakter)" value={yeniSifre} onChange={e => setYeniSifre(e.target.value)} />
                <input type="password" className="form-control" placeholder="Tekrar" value={yeniSifre2} onChange={e => setYeniSifre2(e.target.value)} />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={() => setSifreModal(null)}>İptal</button>
                <button className="btn btn-warning btn-sm" onClick={handleSifreDegistir} disabled={saving}>
                  {saving ? '...' : 'Değiştir'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </PageLayout>
  );
}
